<div class="overlayWrapper">
  <div class="nav-layout" *ngIf="isRouteShow()" [class.navScroll]="didScroll">
    <app-header-top-box></app-header-top-box>
    <app-header></app-header>
  </div>

  <router-outlet></router-outlet>
  <div *ngIf="showPopup" class="cookie-popup" role="dialog" aria-label="Cookie consent">
    <div class="popup-content">
      <div class="text-content">
        <h3>We Use Cookies!</h3>
        <p>
          We use cookies to analyze site traffic and improve your experience. Analytics and
          advertising cookies load only if you accept. See our
          <a href="/privacy-policy" class="privacy-policy">Privacy Policy</a>.
        </p>
        <div class="cookie-actions">
          <button type="button" class="cookie-btn cookie-btn--accept" (click)="acceptCookies()">Accept</button>
          <button type="button" class="cookie-btn cookie-btn--decline" (click)="declineCookies()">Decline</button>
        </div>
      </div>
      <img src="assets/images/cookies-popup.svg" alt="Cookie Duck" class="cookie-image">
      <button class="close-btn" (click)="closePopup()" aria-label="Dismiss">
        <span class="text-icon">✖</span>
        <img class="svg-icon" src="assets/images/close-circle.svg" alt="Close" />
      </button>

    </div>
  </div>

  <app-footer *ngIf="isRouteShow()"></app-footer>
  <app-loading></app-loading>
</div>